import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import ReportsHome from "./components/ReportsHome";

const Reports = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title="Reports" />

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <ReportsHome />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default Reports;
